// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"index__page-spinner___2p9e5","pageSpinner":"index__page-spinner___2p9e5","spin":"index__spin___26W74","small":"index__small___1k_5T"};